import { IRootState } from '../../../../../store'
import { IPulsesState } from '../store/pulses.types'

export const getPulsesSelector = (state: IRootState): IPulsesState => state.pulses
